import { Component, HostBinding, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { INavItem } from 'src/app/interfaces/ICommon';
import { firstValueFrom } from 'rxjs';
import { NavService } from 'src/app/services/nav.service';

@Component({
    selector: 'app-nav-item',
    imports: [TranslateModule, TablerIconsModule, MaterialModule, CommonModule],
    templateUrl: './nav-item.component.html',
    styleUrls: [],
    animations: [
        trigger('indicatorRotate', [
            state('collapsed', style({ transform: 'rotate(0deg)' })),
            state('expanded', style({ transform: 'rotate(180deg)' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4,0.0,0.2,1)'))
        ])
    ]
})
export class AppNavItemComponent implements OnChanges {
  @Output() toggleMobileLink: any = new EventEmitter<void>();
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();

  expanded: any = false;
  disabled: any = false;
  twoLines: any = false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: INavItem | any;
  @Input() depth: any;

  constructor(
    public navService: NavService,
    public router: Router) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnChanges() {
  this.navService.currentUrl.subscribe((url: string) => {
    if (this.item.route && url) {
      if (url.indexOf(`/${this.item.route}`) === 0) {
        this.expanded = true;
      }
      this.ariaExpanded = this.expanded;
    }
  });
}

  isActive(navItem: any) {
    return this.router.url.includes(navItem.route);
  }

  async onItemSelected(item: INavItem) {
    if (!item.children || !item.children.length) {
      if (item.handleRedirect) {
        const routeObservable = item.handleRedirect();
        const route = await firstValueFrom(routeObservable);
        this.router.navigate([route]);
      } else {
        this.router.navigate([item.route]);
      }
      //scroll
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      if (!this.expanded) {
        if (window.innerWidth < 1024 ) {
          this.notify.emit();
        }
      }
    }
    if (item.children && item.children.length) {
      this.expanded = !this.expanded;
    }
  }

  onSubItemSelected(item: INavItem) {
    if (!item.children || !item.children.length) {
      if (this.expanded && window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }
}
